import { render, staticRenderFns } from "./cloud-disk-detail.vue?vue&type=template&id=354cee0a&scoped=true&"
import script from "./cloud-disk-detail.vue?vue&type=script&lang=js&"
export * from "./cloud-disk-detail.vue?vue&type=script&lang=js&"
import style0 from "./cloud-disk-detail.vue?vue&type=style&index=0&id=354cee0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354cee0a",
  null
  
)

export default component.exports